import type { BuiltInLanguage } from './languages';
import type { LanguageTexts } from './types';

/**
 * CDN build: packs are plain JSON files in `lang/` next to kockica.min.js (written by scripts/build-langs.mjs),
 * so a page fetches about 1.5 KB for its language instead of carrying all of them.
 */
let base = '';

/** `scriptSrc` is the URL of kockica.min.js. */
export function setPackBase(scriptSrc: string): void {
  base = scriptSrc.replace(/kockica\.min\.js(\?.*)?$/, '');
}

export function importPack(code: Exclude<BuiltInLanguage, 'en'>): Promise<LanguageTexts> {
  return fetch(`${base}lang/${code}.json`).then((r) => {
    if (!r.ok) throw new Error(`HTTP ${r.status}`);
    return r.json() as Promise<LanguageTexts>;
  });
}
